import { useQuery } from "@tanstack/react-query";
import { API_ROUTES } from "definitions/constants/routeConstants";
import { generatePath } from "react-router";
import apiClient from "services/ApiClient";
import { OnboardingJourneyNetworkRelation } from "models/v2/onboardingJourneyNetworkRelation";

export const networkRelationKeys = {
  all: ["networkRelations"] as const,
  lists: () => [...networkRelationKeys.all, "list"] as const,
  list: (filters: string) => [...networkRelationKeys.lists(), { filters }] as const,
  details: () => [...networkRelationKeys.all, "detail"] as const,
  detail: (id: string) => [...networkRelationKeys.details(), id] as const,
};

export const useNetworkRelationDetailQuery = (id: string | undefined, options: { enabled?: boolean } = {}) => useQuery<OnboardingJourneyNetworkRelation>({
  queryKey: networkRelationKeys.detail(id as string),
  queryFn: () => apiClient.get<OnboardingJourneyNetworkRelation>(
    generatePath(API_ROUTES.onboardingJourneyNetworkRelations.show, { id }),
  ),
  enabled: options?.enabled !== undefined ? options.enabled && !!id : !!id,
});
